import { Component } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { ApiClientService } from '../../../services/api-client.service';
import { ConstantsService } from '../../../services/constants.service';
import { SettingsAmenity } from '../../../types/models';
import { DirectoryService } from '../../../services/directory.service';
import { SettingsAmenitiesService } from '../../../services/settings-amenities.service';
import { environment } from 'environments/environment';
import { AuthTokenService } from '../../../services/auth-token.service';
import { AmenityPaymentMethod } from '../../../types/api-response/amenity/amenity';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-amenities-detailed-view',
    templateUrl: './settings-amenities-detailed-view.component.html',
    styleUrls: ['./settings-amenities-detailed-view.component.scss']
})

export class SettingsAmenitiesDetailedViewComponent {
    title = 'Resident';
    disabledFileInput = false;
    data: SettingsAmenity;
    navPosition = 'general';
    attachments: Array<any> = [];
    timeIntervalsPer = [
        {name: 'day', displayName: 'Per Day'},
        {name: 'week', displayName: 'Per Week'},
        {name: 'month', displayName: 'Per Month'},
        {name: 'year', displayName: 'Per Year'}
    ];
    timeIntervals = [
        {name: 'day', displayName: 'Day'},
        {name: 'week', displayName: 'Week'},
        {name: 'month', displayName: 'Month'},
        {name: 'year', displayName: 'Year'}
    ];
    timeIntervalsExt = [
        {name: 'min', displayName: 'Minute'},
        {name: 'hour', displayName: 'Hour'},
        {name: 'day', displayName: 'Day'},
        {name: 'week', displayName: 'Week'},
        {name: 'month', displayName: 'Month'},
        {name: 'year', displayName: 'Year'}
    ];
    noEdit = false;
    amenityImageBasePath = '../../assets/img/amenity-icons-svg/';
    displayedAmenityImage = 'bbq.svg';
    amenityImages = ['bbq.svg', 'fitness.svg', 'golf.svg', 'guestsuite.svg', 'hobby_room.svg', 'spa.svg',
                     'mediaroom.svg', 'meeting_room.svg', 'party_room.svg', 'pinpong.svg', 'kids_room.svg',
                     'pool_table.svg', 'saunas.svg', 'service_elevator1.svg', 'swimingpool_indoor.svg',
                     'swimingpool_outdoor.svg', 'tennis.svg', 'tv_room.svg', 'elevator.svg', 'library.svg'];

    constructor(
      public api: ApiClientService,
      public settingsAmenitiesService: SettingsAmenitiesService,
      public directoryService: DirectoryService,
      private http: Http,
      private authTokenService: AuthTokenService
    ) {}

    onSubmit(data: any, addTimeSequence = true): void {
        this.noEdit = true;

        if(addTimeSequence) {
            data.timeSequenceType = this.settingsAmenitiesService.selectedItemData.timeSequenceType;
        }

        const url = `/v1/amenity/${this.settingsAmenitiesService.selectedItemData.id}.json`;
        this.settingsAmenitiesService.api.patch('domainAmenities', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            error => this.api.errorHandler(error, 'Update failed!'),
            () => this.noEdit = false
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.settingsAmenitiesService.toggleDetailedView(this.settingsAmenitiesService.selectedItemData, true);
        this.settingsAmenitiesService.getData();
        if (close) this.settingsAmenitiesService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.settingsAmenitiesService.selectedItemData.formFields)
            this.settingsAmenitiesService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    onRestrictionsFieldSubmit(number, selectValue, restrictionType): void {
        let data = null;

        if (!Number.isInteger(+number)) {
            toastr.warning('Only Numbers are allowed for input field in restrictions');
            return;
        }

        if(restrictionType != 'maxTimeForAdvancedBooking' && restrictionType != 'minTimeForAdvancedBooking') {
            if (this.settingsAmenitiesService.selectedItemData.timeSequenceType == 'daily') {
                if (restrictionType == 'bookingsPerUnit')
                    data = {dailyRule: {limitActivityCountBookingOrDays: number, limitActivityRangeValue: selectValue}};
                if (restrictionType == 'timeRequiredBeetween')
                    data = {dailyRule: {minIntervalBetweenBooking: number && selectValue ? (number + ' ' + selectValue) : ''}};
                if (restrictionType == 'technicalBreak')
                    data = {dailyRule: {technicalBreak: number && selectValue ? (number + ' ' + selectValue) : ''}};
            }
            if (this.settingsAmenitiesService.selectedItemData.timeSequenceType == 'hourly') {
                if (restrictionType == 'bookingsPerUnit')
                    data = {hourlyRule: {limitActivityCountBookingOrHours: number, limitActivityRangeValue: selectValue}};
                if (restrictionType == 'timeRequiredBeetween')
                    data = {hourlyRule: {minIntervalBetweenBooking: number && selectValue ? (number + ' ' + selectValue) : ''}};
                if (restrictionType == 'technicalBreak')
                    data = {hourlyRule: {technicalBreak: number && selectValue ? (number + ' ' + selectValue) : ''}};
            }
            if (this.settingsAmenitiesService.selectedItemData.timeSequenceType == 'range') {
                if (restrictionType == 'bookingsPerUnit')
                    data = {rangeRule: {limitActivityCountBooking: number, limitActivityRangeValue: selectValue}};
                if (restrictionType == 'timeRequiredBeetween')
                    data = {rangeRule: {minIntervalBetweenBooking: number && selectValue ? (number + ' ' + selectValue) : ''}};
                if (restrictionType == 'technicalBreak')
                    data = {rangeRule: {technicalBreak: number && selectValue ? (number + ' ' + selectValue) : ''}};
            }
        } else {
            if(this.advancedBookingValuesAreValid(number, selectValue, restrictionType)) {
                if (restrictionType == 'maxTimeForAdvancedBooking')
                    data = {maxTimeForAdvancedBooking: (number ? number + ' ' : '') + selectValue};
                else
                    data = {minTimeForAdvancedBooking: (number ? number + ' ' : '') + selectValue};
            } else
                toastr.warning('Max Time For Advanced Booking cannot be less than Min Time For Advanced Booking');
        }
        this.onSubmit(data);
    }

    advancedBookingValuesAreValid(number, selectValue, restrictionType): boolean {
        let isValid = true;
        let minNumber;
        let minSelectValue;
        let maxNumber;
        let maxSelectValue;
        if((this.settingsAmenitiesService.selectedItemData.minTimeForAdvancedBooking && restrictionType == 'maxTimeForAdvancedBooking')) {
            minNumber = +this.settingsAmenitiesService.selectedItemData.minTimeForAdvancedBooking.split(' ')[0];
            minSelectValue = this.settingsAmenitiesService.selectedItemData.minTimeForAdvancedBooking.split(' ')[1];
            maxNumber = +number;
            maxSelectValue = selectValue;
        }
        if((this.settingsAmenitiesService.selectedItemData.maxTimeForAdvancedBooking && restrictionType == 'minTimeForAdvancedBooking')) {
            minNumber = +number;
            minSelectValue = selectValue;
            maxNumber = +this.settingsAmenitiesService.selectedItemData.maxTimeForAdvancedBooking.split(' ')[0];
            maxSelectValue = this.settingsAmenitiesService.selectedItemData.maxTimeForAdvancedBooking.split(' ')[1];
        }
        const seconds = {
            min: 60,
            hour: 3600,
            day: 86400,
            week: 604800,
            month: 2629744,
            year: 31556926
        };
        if(minNumber * seconds[minSelectValue] > maxNumber * seconds[maxSelectValue])
            isValid = false;

        return isValid;
    }

    addImage(e) {
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 1000000) {
            toastr.warning('Maximum image size is 1MB.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.settingsAmenitiesService.modalSpinnerShow = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainAmenities}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Image path should not be blank.');
                    return;
                }
                this.settingsAmenitiesService.selectedItemData.amenityImage = res.path;
                this.onSubmit({amenityImage: this.settingsAmenitiesService.selectedItemData.amenityImage});
            },
            error => this.api.errorHandler(error, 'Upload file failed'),
            () => {
                this.settingsAmenitiesService.modalSpinnerShow = false;
                this.disabledFileInput = false;
            }
        );
    }

    buildingAmenityFormatConvertion(buildings): any {
        return buildings.map((b) => ({
                   buildingId: b.id,
                   buildingName: this.getBuildingNameById(b.id),
                   amenity : this.settingsAmenitiesService.selectedItemData.id,
                   corporationNumberBd: b.corporationNumberBd,
                   corporationNumberName: b.corporationNumberName,
                   timezone: b.timezone
               }));
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsAmenitiesService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    showNotificationModal(staffOrResident, notificationType): void {
        this.settingsAmenitiesService.isBookingRequestModalShow = true;
        this.settingsAmenitiesService.bookingRequestModalStaffOrResident = staffOrResident;
        this.settingsAmenitiesService.bookingRequestModalNotificationType = notificationType;
    }

    isRestrictionsStringValid(string): boolean {
        return string && Number.isInteger(+string.substr(0, 1));
    }

    submitNotificationsField(): void {
        const data = {
            staffNotificationSettings : [
                {
                    action: 'created',
                    enableStatus: this.settingsAmenitiesService.bookingCreatedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsAmenitiesService['createdStaffMultiselectArray'])
                },
                {
                    action: 'approved',
                    enableStatus: this.settingsAmenitiesService.bookingApprovedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsAmenitiesService['approvedStaffMultiselectArray'])
                },
                {
                    action: 'declined',
                    enableStatus: this.settingsAmenitiesService.bookingDeclinedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsAmenitiesService['declinedStaffMultiselectArray'])
                },
                {
                    action: 'request',
                    enableStatus: this.settingsAmenitiesService.bookingRequestStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsAmenitiesService['requestStaffMultiselectArray'])
                }
            ],
            residentsNotificationSettings : [
                {
                    action: 'created',
                    enableStatus: this.settingsAmenitiesService.bookingCreatedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'approved',
                    enableStatus: this.settingsAmenitiesService.bookingApprovedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'declined',
                    enableStatus: this.settingsAmenitiesService.bookingDeclinedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'request',
                    enableStatus: this.settingsAmenitiesService.bookingRequestResidentCheckbox ? 1 : 0
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, roleName: a.itemName}));
    }

    deleteSelectedAmenity(): void {
        this.settingsAmenitiesService.deleteAmenity(this.settingsAmenitiesService.selectedItemData);
    }

    paymentMethodSubmit(data): void {
        const check = {
            paymentAcceptCash : false,
            paymentAcceptCheques : false,
            paymentAcceptCreditCards: false,
            paymentAcceptCustomType: false
        };
        check.paymentAcceptCash = this.settingsAmenitiesService.selectedItemData.paymentAcceptCash;
        check.paymentAcceptCheques = this.settingsAmenitiesService.selectedItemData.paymentAcceptCheques;
        check.paymentAcceptCreditCards = this.settingsAmenitiesService.selectedItemData.paymentAcceptCreditCards;
        check.paymentAcceptCustomType = this.settingsAmenitiesService.selectedItemData.paymentAcceptCustomType;
        check[Object.keys(data)[0]] = data[Object.keys(data)[0]];
        if(!check.paymentAcceptCash && !check.paymentAcceptCheques && !check.paymentAcceptCreditCards)
            data.defaultPaymentMethod = '';
        if(this.settingsAmenitiesService.selectedItemData.defaultPaymentMethod == AmenityPaymentMethod.credit_card &&
            data.paymentAcceptCreditCards === 0)
            data.defaultPaymentMethod = '';
        if(this.settingsAmenitiesService.selectedItemData.defaultPaymentMethod == AmenityPaymentMethod.cheque &&
            data.paymentAcceptCheques === 0)
            data.defaultPaymentMethod = '';
        if(this.settingsAmenitiesService.selectedItemData.defaultPaymentMethod == AmenityPaymentMethod.cash &&
            data.paymentAcceptCash === 0)
            data.defaultPaymentMethod = '';
        if(this.settingsAmenitiesService.selectedItemData.defaultPaymentMethod == AmenityPaymentMethod.custom_type &&
            data.paymentAcceptCustomType === 0)
            data.defaultPaymentMethod = '';
        this.onSubmit(data);
    }

    changeNavPosition(changeTo): void {
        this.navPosition = changeTo;
    }

    emailTemplateIsSet(type, action) {
        let flag = false;
        this.settingsAmenitiesService.selectedItemData[type + 'NotificationSettings'].forEach((setting) => {
            if(setting.action == action)
                flag = setting.emailTemplate === null && !setting.emailTemplateOtherMessage && !setting.emailTemplateOtherSubject ? false : true;
        });
        return flag;
    }

    showNextAmenityImage() {
        const index = this.amenityImages.indexOf(this.displayedAmenityImage);
        this.displayedAmenityImage = this.amenityImages[index < this.amenityImages.length - 1 ? (index + 1) : 0];
    }

    showPreviousAmenityImage() {
        const index = this.amenityImages.indexOf(this.displayedAmenityImage);
        this.displayedAmenityImage = this.amenityImages[index > 0 ? (index - 1) : (this.amenityImages.length - 1)];
    }

    selectPreloadedAmenityImage() {
        this.settingsAmenitiesService.selectedItemData.amenityImage = (this.amenityImageBasePath + this.displayedAmenityImage);
        this.onSubmit({amenityImage: this.settingsAmenitiesService.selectedItemData.amenityImage});
    }

    imageIsSvg() {
        return this.settingsAmenitiesService.selectedItemData.amenityImage.indexOf('.svg') != -1;
    }

    getDefaultPaymentMethodName() {
        let string = '-';

        if(this.settingsAmenitiesService.selectedItemData.defaultPaymentMethod) {
            if(this.settingsAmenitiesService.selectedItemData.defaultPaymentMethod != 'custom_type')
                string = this.settingsAmenitiesService.selectedItemData.defaultPaymentMethod.replace('_', ' ');
            else
                string = this.settingsAmenitiesService.selectedItemData.paymentCustomTypeName;
        }

        return string;
    }

    editReminder(index) {
        this.settingsAmenitiesService.isRemindersModalShow = true;
        this.settingsAmenitiesService.selectedReminderIndex = index;
    }

    deleteReminder(index) {
        swal(
            ConstantsService.getSwalConfig('Delete Reminder', 'Are you sure you want to delete reminder?'),
            () => {
                this.settingsAmenitiesService.selectedItemData.reminders.splice(index, 1);
                const data = {
                    reminders: this.settingsAmenitiesService.selectedItemData.reminders.map(item => ({
                                   title: item.title,
                                   description: item.description,
                                   conditionDefinition: {
                                       value: item.conditionDefinition.value,
                                       name: item.conditionDefinition.name,
                                       isAfter: item.conditionDefinition.isAfter
                                   },
                                   conditionField: item.conditionField,
                                   subject: item.subject,
                                   template: item.template,
                                   forStaff: item.forStaff,
                                   enableStatus: item.enableStatus,
                                   userRoles: item.userRoles
                               }))
                };
                const url = `/v1/amenity/${this.settingsAmenitiesService.selectedItemData.id}.json?expand=reminders`;
                this.settingsAmenitiesService.api.patch('domainAmenities', url, data).subscribe(
                    (result) => {
                        this.settingsAmenitiesService.selectedItemData = result;
                        this.updateView('Reminder has been removed successfully', false);
                    },
                    error => this.api.errorHandler(error, 'Delete failed!')
                );
            }
        );
    }

    changeReminderStatus(event, index) {
        let data = JSON.parse(JSON.stringify(this.settingsAmenitiesService.selectedItemData.reminders));
        data[index].enableStatus = event.target.checked;
        data = data.map(item => ({
            title: item.title,
            description: item.description,
            conditionDefinition: {
                value: item.conditionDefinition.value,
                name: item.conditionDefinition.name,
                isAfter: item.conditionDefinition.isAfter
            },
            conditionField: item.conditionField,
            subject: item.subject,
            template: item.template,
            forStaff: item.forStaff,
            enableStatus: item.enableStatus,
            userRoles: item.userRoles
        }));
        this.onSubmit({reminders: data});
    }

    residentOccupancyTypesFormatConvertion(array) {
        return array.map(o => ({
                   code: o.id,
                   name: o.itemName
               }));
    }

    userGroupsFormatConvertion(array) {
        return array.map(o => ({
                   bdId: o.id,
                   name: o.itemName
               }));
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities-detailed-view/settings-amenities-detailed-view.component.ts